
let lazyImageObserver;

function init() {

	let lazyImages = Array.from(document.querySelectorAll('.lazy'));
	
	if ('IntersectionObserver' in window && !Shopify.designMode) {
		lazyImageObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					let lazyImage = entry.target;
					lazyImage.src = lazyImage.dataset.src ? lazyImage.dataset.src : '';
					lazyImage.srcset = lazyImage.dataset.srcset ? lazyImage.dataset.srcset : '';
					
					lazyImage.onload = () => {
						lazyImage.classList.add('lazy-loaded');
						if (lazyImage.closest('.frame')) {
							lazyImage.closest('.frame').classList.add('child-loaded');
						} 
						lazyImageObserver.unobserve(lazyImage);
					};
				}
			});
		});

		lazyImages.forEach(function(image) {
			lazyImageObserver.observe(image);
		});
		
	} else {
		// Possibly fall back to a more compatible method here
		lazyImages.forEach(function(lazyImage) {
			lazyImage.dataset.src ? 	lazyImage.src = lazyImage.dataset.src : null;
			lazyImage.dataset.srcset ? lazyImage.srcset = lazyImage.dataset.srcset : null;
			lazyImage.classList.add('lazy-loaded');
			if (lazyImage.closest('.frame')) {
				lazyImage.closest('.frame').classList.add('child-loaded');
			} 
		});
	}
}

function destroy() {
	lazyImageObserver.disconnect();
}

const checkImage = (el) => {
	let path = el.dataset.src;
	new Promise(resolve => {
		const img = new Image();
		img.onload = () => resolve({path, status: 'ok'});
		img.onerror = () => resolve({path, status: 'error'});
		img.src = path;
	});
};


export default {
	destroy: destroy,
	init: init 
};